import { Suspense } from 'react'
import { Routes, Route } from 'react-router-dom'

import DefaultLayout from 'layouts/defaultLayout'
import Main from './pages/main'
import Speed from 'pages/prun/speed'
import Cushion from 'pages/prun/cushion'
import CushionView from 'pages/prun/cushionView'
import Protection from 'pages/prun/protection'
import Bounce from 'pages/prun/bounce'
import BounceView from 'pages/prun/bounceView'
import Trail from 'pages/prun/trail'
import TrailView from 'pages/prun/trailView'
import SpeedView from 'pages/prun/speedView'
import ProtectionView from 'pages/prun/protectionView'

import CpsList from 'pages/cps/cpsList'
import CpsView from 'pages/cps/cpsView'

import IndoorList from 'pages/cps/indoor'
import IndoorView from 'pages/cps/indoorView'

import TrackList from 'pages/cps/track'
import TrackView from 'pages/cps/trackView'

import SpsList from 'pages/sps/spsList'
import SpsView from 'pages/sps/spsView'

import OthersList from 'pages/cps/others'
import VollyBallList from 'pages/cps/vollyBall'

import { useIdleTimer } from 'react-idle-timer'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { selectUrl } from 'hooks/urlInfo'
import GlobalStyles from './components/GlobalStyles'
import CpsList2026 from 'pages/cps/cpsList_2026'
import CpsView2026 from 'pages/cps/cpsView_2026'

// import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

function App() {
	// const queryClient = new QueryClient()
	const urlInfo = useSelector(selectUrl)
	const navigate = useNavigate()

	const onPrompt = () => {
		// Fire a Modal Prompt
		console.log('onPrompt')
	}

	const onIdle = () => {
		console.log('onIdle', urlInfo)
		window.location.href = `${urlInfo}`
		// urlInfo에 ?가 있으면 &nocache=${new Date().getTime() 없으면 ?nocache=${new Date().getTime() 추가
		// if (urlInfo.indexOf('?') > 0) {
		// 	// urlInfo에 nocache가 있으면 해당 파라미터의 값을 변경
		// 	if (urlInfo.indexOf('nocache') > 0) {
		// 		const urlInfoArr = urlInfo.split('&')
		// 		const urlInfoArr2 = urlInfoArr.filter((item: any) => {
		// 			return item.indexOf('nocache') < 0
		// 		})
		// 		window.location.href = `${urlInfoArr2.join(
		// 			'&',
		// 		)}&nocache=${new Date().getTime()}`
		// 	} else {
		// 		window.location.href = `${urlInfo}&nocache=${new Date().getTime()}`
		// 	}
		// } else {
		// 	window.location.href = `${urlInfo}?nocache=${new Date().getTime()}`
		// }
	}

	const onActive = (event: any) => {
		//console.log('onActive', event)
		// Close Modal Prompt
		// Do some active action
		// console.log('onActive 1')
	}

	const onAction = (event: any) => {
		//console.log('onAction', event)
		// Do something when a user triggers a watched event
		// console.log('onAction 2')
	}

	const {
		start,
		reset,
		activate,
		pause,
		resume,
		isIdle,
		isPrompted,
		isLeader,
		getTabId,
		getRemainingTime,
		getElapsedTime,
		getLastIdleTime,
		getLastActiveTime,
		getTotalIdleTime,
		getTotalActiveTime,
	} = useIdleTimer({
		onPrompt,
		onIdle,
		onActive,
		onAction,
		timeout: 5 * 60 * 1000, // 5분
		promptTimeout: 0,
		events: [
			'mousemove',
			'keydown',
			'wheel',
			'DOMMouseScroll',
			'mousewheel',
			'mousedown',
			'touchstart',
			'touchmove',
			'MSPointerDown',
			'MSPointerMove',
			'visibilitychange',
		],
		immediateEvents: [],
		debounce: 0,
		throttle: 0,
		eventsThrottle: 200,
		element: document,
		startOnMount: true,
		startManually: false,
		stopOnIdle: false,
		crossTab: false,
		name: 'idle-timer',
		syncTimers: 0,
		leaderElection: false,
	})

	return (
		// <QueryClientProvider client={queryClient}>
		<Suspense fallback={<div />}>
			<GlobalStyles />
			<DefaultLayout>
				<>
					<Routes>
						<Route
							path="/"
							element={<Main />}
						/>
						<Route
							path="/prun/speed"
							element={<Speed />}
						/>
						<Route
							path="/prun/speed/view"
							element={<SpeedView />}
						/>
						<Route
							path="/prun/cushion"
							element={<Cushion />}
						/>
						<Route
							path="/prun/cushion/view"
							element={<CushionView />}
						/>
						<Route
							path="/prun/protection"
							element={<Protection />}
						/>
						<Route
							path="/prun/protection/view"
							element={<ProtectionView />}
						/>
						<Route
							path="/prun/bounce"
							element={<Bounce />}
						/>
						<Route
							path="/prun/bounce/view"
							element={<BounceView />}
						/>
						<Route
							path="/prun/trail"
							element={<Trail />}
						/>
						<Route
							path="/prun/trail/view"
							element={<TrailView />}
						/>
						<Route
							path="/sps/list"
							element={<SpsList />}
						/>
						<Route
							path="/sps/view"
							element={<SpsView />}
						/>
						<Route
							path="/cps/tennis"
							element={<CpsList />}
						/>
						<Route
							path="/cps/tennis/view"
							element={<CpsView />}
						/>
						<Route
							path="/cps/indoor"
							element={<IndoorList />}
						/>
						<Route
							path="/cps/indoor/view"
							element={<IndoorView />}
						/>
						<Route
							path="/cps/view"
							element={<CpsView2026 />}
						/>
						<Route
							path="/cps/track"
							element={<TrackList />}
						/>
						<Route
							path="/cps/volleyball"
							element={<VollyBallList />}
						/>
						<Route
							path="/cps/track/view"
							element={<TrackView />}
						/>
						<Route
							path="/cps/others"
							element={<OthersList />}
						/>
						<Route
							path="cps/list"
							element={<CpsList2026 />}
						/>
					</Routes>
				</>
			</DefaultLayout>
		</Suspense>
		// </QueryClientProvider>
	)
}

export default App
